@import "~/styles/variables";

.Wrapper {
  align-items: flex-start;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 99;
}

.Inner {
  @include scale-in;
  position: absolute;
}
